export default {
    countries: 'countries',
    countriesTitle: 'Title',
    countriesStatus: 'Status',
    editCountries: 'Edit countries',
    addCountries: 'New countries',
    isArabCountry : 'is Arab Country',
    countriesCode : 'countries Code (IR)',
    dialCode : 'dial Code (98)',
}